import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AvatarUser } from './types';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-user-avatar-with-extended-info',
  templateUrl: `./user-avatar-with-extended-info.component.html`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TooltipModule],
})
export class UserAvatarWithExtendedInfoComponent {
  @Input() users: AvatarUser[];
  @Input() maxVisibleUsers = 5;
  @Input() showAdminCrown = false;
  @Input() containerClass = '';

  getVisibleUsers(): AvatarUser[] {
    if (this.maxVisibleUsers === 0) {
      return this.users;
    }
    return this.users.slice(0, this.maxVisibleUsers);
  }

  getNotVisibleUsersCount(): number {
    if (this.maxVisibleUsers <= 0) {
      return 0;
    }
    return Math.max(0, this.users.length - this.maxVisibleUsers);
  }

  getAvatarBgColor(user: AvatarUser): string {
    if (user.role?.toLocaleLowerCase() === 'admin') {
      return 'bg-bl-blue-light-800 ring-bl-blue-light-600';
    }
    return 'bg-bl-blue-light-600';
  }
}
